import { useState, useEffect, useContext,useRef,useMemo,useLayoutEffect  } from "react";
import { Input, Select, Button, Empty, Checkbox, Skeleton, Tag, message, Tooltip,Radio } from "antd";
import Services from "../network/Services";
import { isNullUndefine, capitalizeFirstLetter, formatPhoneNumber, formatPhoneNumber_Without_CC,formatPhoneNumberWithoutCntryCode,formatPhoneNumberWithoutCntryCode_WIthoutBracket } from "../control/Constant";
import { UserContext } from "../App";
import AddProfessional from "./AORG Professionals/Add Professionals/AddProfessional";
import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
import { useCallback } from "react";
import XLSX from "xlsx-js-style";

const PreferredProfessional2 = () => {

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const { setLoader } = useContext(UserContext);
  const [type, setType] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [latLongAgnt, setLatLongAgnt] = useState({ latitude: null, longitude: null });
  const [keyDownState, setKeyDownState] = useState(true);
  const [professionalList, setProfessionalList] = useState([]);
  const [searchPageNumber, setSearchPageNumber] = useState(1);
  const [showAddNewPopup, setShowAddNewPopup] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [selectedProfessionalType, setSelectedProfessionalType] = useState("");
  const [selectedProfessionalValue, setSelectedProfessionalValue] = useState("");
  const [specialty, setSelectSpecialty] = useState(null);
  const [searchType, setsearchType] = useState(null);
  const btnStyle = { height: "2.5rem", border: '1px solid #333', borderRadius: "6px" };
  const inputStyle = { border: "1px solid #333", color: "#333", placeholderColor: "#333" };
  const [inputValue, setInputValue] = useState("");
  const [selectedProSubType, setSelectedProSubType] = useState([]);
  const [isBoardCertified, setIsBoardCertified] = useState([
  {label: "Board Certified",value: true,checked: false, }, {label: "Non-Board Certified",value: false,checked: false,}]);
  const hasPriorityOne = professionalList?.some( item =>
    item?.differentPriorityLevelIds && item?.differentPriorityLevelIds?.length > 0
  );
  const dropdownRef = useRef();
  const dropdownRef1 = useRef();
  const dropdownRef3 = useRef();
  const dropdownRef4=useRef();
  const [tempJsonObj,setTempJsonObj]=useState([])
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState([]);
  const [subCategory, setSubCategory] = useState("");
  const [selectedProType, setSelectedProType] = useState([]);
  const [getGeriatricianSubTypeIds,setgetGeriatricianSubTypeIds]=useState([])
  const [prefereds, setPrefereds] = useState([]);
  const [getLength, setGetLength] = useState("");
  const [openSelectId, setOpenSelectId] = useState(null);
  const [open1,setOpen1]=useState(false)
  const [open3,setOpen3]=useState(false)
  const [suggestions, setSuggestions] = useState([]); 
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [isFocused, setIsFocused] = useState(true); //false
  const [userLocation, setUserLocation] = useState(null);
  const chipsContainerRef = useRef(null);
  const [checkedPlaces, setCheckedPlaces] = useState([]);
  const containerRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(getLength?.length || 1);


  const returnSubType = (proTypeId) => {
    const filteredData = selectedProSubType?.filter(item => selectedProType.includes(String(item.proTypeId)));
    return filteredData?.map(item => ({ label: item.proSubType, value: item.proSubTypeId })) || [];
  }


useEffect(() => {

  const script = document.createElement("script");

  const APiKey="AIzaSyBaUn22pwovCzOxH7Uthivbd8_ScMkaEAI"

  script.src =`https://maps.googleapis.com/maps/api/js?key=${APiKey}&libraries=places`
  script.async = true;

  document.head.appendChild(script);
  navigator.geolocation.getCurrentPosition( 
      (position) => { setUserLocation({ lat: position.coords.latitude, lng: position.coords.longitude, }); 
    } );

}, []);



useLayoutEffect(() => {
  const calculateVisible = () => {
    const container = containerRef.current;

    if (!container) return;

    const containerWidth = container.offsetWidth;

    const chips = Array.from(
      container.querySelectorAll(".chip-item")
    );
    // console.log("fweC",containerWidth,"__",chips)

    if (!chips.length) return;

    let usedWidth = 0;
    let visible = 0;
    const reservedWidth = 200;

    for (let i = 0; i < chips.length; i++) {
      const chipWidth = chips[i].offsetWidth ;
      // console.log("chipWidth",chipWidth)
      if (
        usedWidth + chipWidth + reservedWidth >
        containerWidth
      ) {
        break;
      }
      // console.log("qwdA_usedWidth",usedWidth,"__chipWidth",chipWidth,"_containerWidth",containerWidth)
      // console.log("feS",usedWidth + chipWidth + reservedWidth)
      usedWidth += chipWidth + 8;

      visible++;
    }
    // console.log("usedWidth",usedWidth)

    setVisibleCount(visible);
  };

  requestAnimationFrame(calculateVisible);

  window.addEventListener("resize", calculateVisible);

  return () => {
    window.removeEventListener("resize", calculateVisible);
  };
}, [getLength]);



  const removeDuplicate = (arr) => {
    const seenUserIds = new Map();
    const seenEmails = new Set();

    arr?.forEach(item => {
      if (seenUserIds.has(item.proUserId)) return;

      const email = item?.proPrimaryEmail?.trim()?.toLowerCase();
      const isValidEmail = email && !email.endsWith("@aorg.com");

      if (isValidEmail) {
        if (seenEmails.has(email)) return; 
        seenEmails.add(email);
      }

      seenUserIds.set(item.proUserId, item);
    });

    return Array.from(seenUserIds.values());
  };


  const onChangingProfessSelection = (element, checkedData, types) => {
    const newtype = types
    const eventChecked = element?.target?.checked;
    setProfessionalList(prev =>
      prev?.map(value =>
        value?.userId === checkedData?.userId ? { ...value, [newtype]: eventChecked } : value
      )
    );
  };



  const getMedicaidText = (item) => {
    const id = item?.medicaidAcceptanceId;
    if (isNullUndefine(id)) return null;
    if (id == 1) return { text: "Medicaid acceptance likely", highlight: true };
    if (id == 2) return { text: "Medicaid Acceptance Available", highlight: true };
    if (id == 3) return { text: "Does Not Accept Medicaid", highlight: false };
    return { text: "" };
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef1.current && !dropdownRef1.current.contains(e.target)) {
        setOpen1(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  //


useEffect(() => {

  const handleOutsideClick = (event) => {

    if (
       ( dropdownRef4.current && !dropdownRef4.current.contains(event.target))
    ) {
      setInputValue("");
      setOpen3(false);
      setIsFocused(false);
      

    }

  };

  document.addEventListener(
    "mousedown",
    handleOutsideClick
  );

  return () => {

    document.removeEventListener(
      "mousedown",
      handleOutsideClick
    );

  };

}, []);


  

  const getBoardValue = () => {

    const boardChecked =
      isBoardCertified?.find(x => x.value === true)?.checked;

    const nonBoardChecked =
      isBoardCertified?.find(x => x.value === false)?.checked;
    if (boardChecked && nonBoardChecked) {
      return null;
    }
    if (!boardChecked && !nonBoardChecked) {
      return null;
    }
    if (boardChecked) {
      return true;
    }
    if (nonBoardChecked) {
      return false;
    }
    return null;
  };

  const buildPayload = (pageNumber,fetchSubCategriesResponse,fetchSubProTypeResponse,fetchCheckedSubGeriatricianTypeResponse) => ({
    searchName: inputValue || null,
    searchTypeId : searchType || null,
    rowsOfPage: 10,
    proSerDescIds: specialty ?? null,
    pageNumber,
    // IsBoardTrue : isBoardCertified,
    IsBoardTrue: getBoardValue(),
    proTypeIds: fetchSubCategriesResponse?.length ? fetchSubCategriesResponse.join(",") : null,
    proSubTypeIds:fetchSubProTypeResponse?.length ? fetchSubProTypeResponse.join(",") : null,
    proGeriatricianSubTypeIds:fetchCheckedSubGeriatricianTypeResponse?.length ? fetchCheckedSubGeriatricianTypeResponse.join(",") : null,
    differentPriorityLevelIds: prefereds?.length ? prefereds : null,
    selectedLocations:selectedLocations?.length>0?selectedLocations?.map((value1)=>({"Value":value1?.Value,"Type":value1?.Type})):[]

  });

  const specialtyType = [
    { label: "Health", value: "1" },
    { label: "Housing", value: "2" },
    { label: "Finance", value: "3" },
    { label: "Legal", value: "4" },
    { label: "Other", value: "5" }
  ];
  const preferedType = [
    { label: "Global", value: 1 },
    // { label: "Location", value: 2 },
    // { label: "Zip Code", value: 3 },
    // { label: "State", value: 4 },
    // { label: "City", value: 5 },
    // { label: "County", value: 6 }, 
    // { label: "National", value: 7 }
  ];


  const parentNodeCheck = (typeData,val,NodeType) => {
    const checkedValue=val?.target?.checked
    const selectedTypeData=typeData
    const selectedNodeValue=typeData?.value
    // console.log("esax",selectedTypeData,"__NodeType",NodeType)
    // console.log("4efwd",selectedNodeValue)

    setTempJsonObj(prev =>
     {
      return prev.map((temJsonValu1)=>{
        if(temJsonValu1.value==specialty){
          let temJsonValu1_varibale=temJsonValu1
          // console.log("2fewcs",temJsonValu1)
          const updatedParent=temJsonValu1?.professionalTypes?.map((Tempvalues)=>{
            let professionalSubTypesConst=Tempvalues
            if(NodeType=="childNode"){
              if(checkedValue==false){
                const filterMapInnerSubArray =
                   professionalSubTypesConst?.professionalSubTypes?.map((value5) => ({
                     ...value5,
                     professionalGeriatricianSubTypes:
                       value5?.professionalGeriatricianSubTypes?.map((value6) =>
                            ({ ...value6, checked:false })
                       ),
                       checked:false
                   }));

                 return {
                   ...Tempvalues,
                   professionalSubTypes: filterMapInnerSubArray,
                 };
               }

              professionalSubTypesConst=professionalSubTypesConst?.professionalSubTypes?.map((temp1)=>{
                  return (temp1?.value==selectedTypeData?.value)?{...temp1,"checked":checkedValue}:temp1
                })
                return {...Tempvalues,"professionalSubTypes":professionalSubTypesConst}
            }

            if (NodeType == "subChildNode") {
              if (selectedTypeData?.label === "MD" && checkedValue === false) {
              setIsBoardCertified(prev =>
                prev.map(v => ({
                  ...v,
                  checked: false
                }))
              );
            }
              const filterMapInnerSubArray = professionalSubTypesConst?.professionalSubTypes?.map((value5) => ({
                  ...value5,
                  professionalGeriatricianSubTypes:
                    value5?.professionalGeriatricianSubTypes?.map((value6) =>
                      value6?.value == selectedTypeData?.value
                        ? { ...value6, checked: checkedValue }
                        : value6
                    ),
                }));

              return {
                ...Tempvalues,
                professionalSubTypes: filterMapInnerSubArray,
              };
            }


            if(checkedValue==false && NodeType=="parentNode"){
              professionalSubTypesConst=professionalSubTypesConst?.professionalSubTypes?.map((temp2)=>{
                return {...temp2,
                          "checked":false,
                          professionalGeriatricianSubTypes:
                          temp2?.professionalGeriatricianSubTypes?.map((value6) =>
                                ({ ...value6, checked:false })
                           )
                      ,}
              })
              return (Tempvalues?.value==selectedTypeData?.value)?{...Tempvalues,"checked":checkedValue,"professionalSubTypes":professionalSubTypesConst}:Tempvalues
            }

            // console.log("rbeavsd",checkedValue , NodeType)
            return (Tempvalues?.value==selectedTypeData?.value)?{...Tempvalues,"checked":checkedValue}:Tempvalues
          })



          // console.log("efwdc",updatedParent)

          temJsonValu1_varibale={...temJsonValu1_varibale,"professionalTypes":updatedParent}

          // console.log("qdasx",temJsonValu1_varibale)
          return temJsonValu1_varibale
        }
        return temJsonValu1
      })

       }
    );
  };

  async function fetchSubCategries(){

          let getSubCatValue=[]
          const findCheckedSubcategories=tempJsonObj?.map(value1=>{
                return value1?.professionalTypes?.map((value2)=>{
                  if(value2?.checked==true){
                    getSubCatValue?.push(value2.value)
                    return value2
                  }
                  return value2
                })
          })
          // console.log("24q53gw",getSubCatValue)
          setSubCategory(getSubCatValue)
          return getSubCatValue

  }

  async function fetchSubCategriesLabel(){
    let getSubCatValueLabel=[]
    const findCheckedSubcategories=tempJsonObj?.map(value1=>{
          return value1?.professionalTypes?.map((value2)=>{
            if(value2?.checked==true){
              getSubCatValueLabel?.push(value2.label)
              return value2
            }
            return value2
          })
    })
    // console.log("24q53gw",getSubCatValue)
    return getSubCatValueLabel

}




async function fetchSubProType(){

  let getSubProType=[]
  const findCheckedSubProType=tempJsonObj?.map(value1=>{
    return value1?.professionalTypes?.map((value2)=>{
      return value2?.professionalSubTypes?.map((value3)=>{
        if(value3?.checked==true){
          getSubProType?.push(value3.value)
          return value3
        }
        return value3
      })

    })
  })
  // console.log("55524q53gw",getSubProType)
  setSelectedProType(getSubProType)
  return getSubProType

 }

 async function fetchSubProTypeLabel(){

  let getSubProTypeLabel=[]
  const findCheckedSubProType=tempJsonObj?.map(value1=>{
    return value1?.professionalTypes?.map((value2)=>{
      return value2?.professionalSubTypes?.map((value3)=>{
        if(value3?.checked==true){
          getSubProTypeLabel?.push(value3.label)
          return value3
        }
        return value3
      })

    })
  })
  // console.log("55524q53gw",getSubProTypeLabel)
  // setSelectedProType(getSubProType)
  return getSubProTypeLabel

 }


  async function fetchCheckedSubGeriatricianType(){

    let getGeriatricianSubIds=[]
    const findCheckedSubGeriatricianType=tempJsonObj?.map(value1=>{
      return value1?.professionalTypes?.map((value2)=>{
        return value2?.professionalSubTypes?.map((value3)=>{
          return value3?.professionalGeriatricianSubTypes?.map((value4)=>{
          if(value4?.checked==true){
            getGeriatricianSubIds?.push(value4.value)
            return value4
          }
          return value4
        })
      })
      })
    })

    // console.log("12355524q53gw",getGeriatricianSubIds)
    setgetGeriatricianSubTypeIds(getGeriatricianSubIds)
    return getGeriatricianSubIds

  }


  async function fetchCheckedSubGeriatricianTypeLabel(){

    let getGeriatricianSubIdsLabel=[]
    const findCheckedSubGeriatricianType=tempJsonObj?.map(value1=>{
      return value1?.professionalTypes?.map((value2)=>{
        return value2?.professionalSubTypes?.map((value3)=>{
          return value3?.professionalGeriatricianSubTypes?.map((value4)=>{
          if(value4?.checked==true){
            getGeriatricianSubIdsLabel?.push(value4.label)
            return value4
          }
          return value4
        })
      })
      })
    })

    // console.log("12355524q53gw",getGeriatricianSubIdsLabel)
    // setgetGeriatricianSubTypeIds(getGeriatricianSubIdsLabel)
    return getGeriatricianSubIdsLabel

  }




  const fetchData = async (pageNumber = 1, isNew = false) => {
    if (loading) return;
    const fetchSubCategriesResponse=await fetchSubCategries()
    const fetchSubProTypeResponse=await fetchSubProType()
    const fetchCheckedSubGeriatricianTypeResponse=await fetchCheckedSubGeriatricianType()

    // console.log("4few",fetchSubCategriesResponse,"__",fetchSubProTypeResponse,"__",fetchCheckedSubGeriatricianTypeResponse)
    setLoader(true);

    try {
      const res = await Services.getProfessionalListv2(buildPayload(pageNumber,fetchSubCategriesResponse,fetchSubProTypeResponse,fetchCheckedSubGeriatricianTypeResponse));
      const data = res?.data?.data || [];
      // ✅ CASE 1: NO DATA FOUND
      if (data?.length === 0) {
        if (isNew) {
          setProfessionalList([]); // clear list
        }
        setHasMore(false);
        // 🔥 show message only on first search
        if (isNew) {
          message.info("No professionals found");
        }
        return;
      }

      // ✅ NORMAL FLOW
      // const resultProfessArr = data.map(v => ({
      //   ...v,
      //   isLocationChecked: v.priorityLevelId == 1,
      //   isGLobalChecked: v.globelPriLevId == 1,
      //   professStatus: 0,
      //   differentPriorityLevelIds :[]
      // }));
      // const resultProfessArr = data.map(v => ({...v,
      //   isLocationChecked: v.priorityLevelId == 1,
      //   isGLobalChecked: v.globelPriLevId == 1,
      //   professStatus: 0,
      //   differentPriorityLevelIds: v?.differentPriorityLevelIds || [],
      //   originalDifferentPriorityLevelIds: v?.differentPriorityLevelIds || [],
      // }));

     const resultProfessArr = data?.map((v) => {

  const differentPriorityLevelIds = [...(v?.differentPriorityLevelIds || []), ...(v?.globelPriLevId == 1 ? [1] : []),];

  // REMOVE DUPLICATES + SORT
  // const finalPriorityIds = [...new Set(differentPriorityLevelIds)]?.sort((a, b) => a - b);
  const finalPriorityIds = [...new Set(differentPriorityLevelIds)]?.filter(id => [1, 3, 4, 5, 6, 7].includes(id))?.sort((a, b) => a - b);
  return {
    ...v,

    isLocationChecked: v?.priorityLevelId == 1,
    isGLobalChecked: v?.globelPriLevId == 1,
    professStatus: 0,
    differentPriorityLevelIds: finalPriorityIds,
    originalDifferentPriorityLevelIds: finalPriorityIds,
  };
});

      const updatedList = isNew  ? resultProfessArr  : [...professionalList, ...resultProfessArr];
      setProfessionalList(updatedList);
      // const hasPriorityOne = updatedList.some(item => (item.priorityLevelId == 1 || item?.globelPriLevId == 1));
      const hasPriorityOne = professionalList?.some( item =>
      item?.differentPriorityLevelIds && item?.differentPriorityLevelIds?.length > 0
    );
      setIsUpdate(false);

      const PAGE_SIZE = 10;
      setHasMore(data?.length > 0);

    } catch (error) {

      // ❌ ERROR HANDLING
      // console.error("API ERROR:", error);
      setHasMore(false);
      setProfessionalList(prev => (isNew ? [] : prev));
      message.error(error?.response?.data?.message || "No matching professional found.");

    } finally {
      setLoader(false);
    }
  };

  const addBorder = (pdf, pageWidth, pageHeight) => {
    pdf.setDrawColor(114, 12, 32);
    pdf.setLineWidth(0.8);
    // pdf.rect(4, 4, pageWidth - 8, pageHeight - 8);
    pdf.rect(2, 2, pageWidth - 4, pageHeight - 4);
    pdf.setTextColor(0, 0, 0);
  };

  const addHeaderAndBorder = (pdf, pageWidth, pageHeight) => {
    // Border
    addBorder(pdf, pageWidth, pageHeight);

    // Header background
    pdf.setFillColor(114, 12, 32);
    // pdf.rect(4, 4, pageWidth - 8, 14, "F");
    pdf.rect(2, 2, pageWidth - 4, 18, "F");

    // Header title
    pdf.setTextColor(255, 255, 255);
    pdf.setFontSize(13);
    pdf.setFont("helvetica", "bold");
    pdf.text("Strategic Partners", pageWidth / 2, 12, { align: "center" });
    pdf.setTextColor(0, 0, 0);
  };

 const getBase64Image = (url) => {
  return new Promise((resolve) => {
    if (!url) return resolve(null);

    const isLocalAsset =
      url.startsWith("./") || url.startsWith("/");
    if (isLocalAsset) {
      const img = new Image();
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth || 100;
          canvas.height = img.naturalHeight || 100;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        } catch (e) {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
      img.src = url + "?v=" + Date.now();
    return;
   }

    fetch(url, {  mode: "cors",  cache: "no-cache",})
     ?.then((res) => {
        if (!res.ok) throw new Error("Failed");
        return res.blob();
      })
      ?.then((blob) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result || null);
        reader.onerror = () => resolve(null);
        reader.readAsDataURL(blob);
      })
      .catch(() => resolve(null));
  });
 };

 
      function getAddressFun(item) { // Show zip,state,city,county 
        const county = (!isNullUndefine(item?.addressCoutry) && item?.addressCoutry !== "County not found") ? ","+item?.addressCoutry : "";
        const result=((!isNullUndefine(item?.addressZipcode))?item?.addressZipcode:"")+((!isNullUndefine(item?.addressState))?","+item?.addressState:"") + ((!isNullUndefine(item?.addressCity))?","+item?.addressCity:"")+county
        return result || ""
      }


 const handlePrintPDF = async () => {
        
          const data = removeDuplicate(professionalList);

          if (!data?.length) {
            message.info("No professionals available to download");
            return;
          }

          setLoader(true);

          const pdf = new jsPDF({
            orientation: "p",
            unit: "mm",
            format: "a4",
            compress: true,
          });

          const pageWidth = 210;
          const pageHeight = 297;
          const margin = 8;
          const gap = 5;
          const cardWidth = (pageWidth - margin * 2 - gap) / 2;
          const cardHeight = 41;

          // const tagH = 5;
          // const tagPad = 2;
          // const tagGap = 2;
          // const tagRowGap = 2.5;

          let x = margin;
          let y = 25;

          addHeaderAndBorder(pdf, pageWidth, pageHeight);

          const imagePromises = data.map((item) => getBase64Image(item?.profileURL));
          const images = await Promise.all(imagePromises);

          const phoneIconBase64 = await getBase64Image("./call.svg");
          const emailIconBase64 = await getBase64Image("./mail.svg");
          const dummyIconBase64 = await getBase64Image("./professionalDummyIcon.svg");
          const locationIconBase64 = await getBase64Image("./location_on.svg");

          // const getTagW = (pdf, label) => {
          //   pdf.setFontSize(5);
          //   const charWidth =
          //     (pdf.getStringUnitWidth(label) * 5) / pdf.internal.scaleFactor;
          //   return charWidth + tagPad * 2;
          // };

          // const drawTagsAutoWrap = ( pdf, tags, startY, item, tagAreaLeft, cardX, cardWidth) => {
          //   const tagAreaRight = cardX + cardWidth - 3;

          //   let tagX = tagAreaLeft;
          //   let rowY = startY;

          //   tags.forEach((pref) => {
          //     const active = item?.differentPriorityLevelIds?.includes(pref.value);
          //     const label = pref.label;
          //     const tw = getTagW(pdf, label);

          //     if (tagX + tw > tagAreaRight) {
          //       tagX = tagAreaLeft;
          //       rowY += tagH + tagRowGap;
          //     }

          //     if (active) {
          //       pdf.setFillColor(34, 197, 94);
          //       pdf.setTextColor(255, 255, 255);
          //         } else {
          //       pdf.setFillColor(209, 213, 219);
          //       pdf.setTextColor(80, 80, 80);
          //     }

          //     pdf.roundedRect(tagX, rowY, tw, tagH, 2, 2, "F");
          //     pdf.setFontSize(5);
          //     pdf.text(label, tagX + tagPad, rowY + 3.5);
          //     tagX += tw + tagGap;
          //   });
          // };

          const addPageNumber = (pdf, pageNum, totalPages) => {
            pdf.setFont("helvetica", "normal");
            pdf.setFontSize(8);
            pdf.setTextColor(0, 0, 0); 
            const text = `Page ${pageNum} of ${totalPages}`;
            const textW = (pdf.getStringUnitWidth(text) * 8) / pdf.internal.scaleFactor;
            pdf.text(text, (pageWidth - textW) / 2, pageHeight - 4);
          };

          for (let i = 0; i < data?.length; i++) {
            const item = data[i];
            const image = images[i];

            if (y + cardHeight > pageHeight - 10) {
              pdf.addPage();
              addBorder(pdf, pageWidth, pageHeight);
              x = margin;
              y = margin + 5;
            }

            pdf.setDrawColor(220, 220, 220);
            pdf.setLineWidth(0.3);
            pdf.roundedRect(x, y, cardWidth, cardHeight, 3, 3);

            const imgSize = 26;
            const imgX = x + 3;
            const imgY = y + 3;

            if (image) {
              pdf.addImage(image, undefined, imgX, imgY, imgSize, imgSize);
            } else if (dummyIconBase64) {
              pdf.addImage(dummyIconBase64, undefined, imgX, imgY, imgSize, imgSize);
            } else {
              pdf.setFillColor(220, 220, 220);
              pdf.roundedRect(imgX, imgY, imgSize, imgSize, 2, 2, "F");
            }

            const nameX = x + 32;
            const iconSize = 3.2;
            const textAfterIcon = nameX + iconSize + 1.2;
            const maxW = cardWidth - 34;

            const rowName = y + 7;
            const hasBoardCertified = !isNullUndefine(item?.board);
            const boardBadgeH = 5.5;
            const boardBadgeGap = 2;
            const boardOffset = hasBoardCertified ? boardBadgeH + boardBadgeGap : 0;
            const rowAddress = y + 12 + boardOffset;

            pdf.setFont("helvetica", "normal");
            pdf.setFontSize(8);
            pdf.setTextColor(60, 60, 60);

            const address =getAddressFun(item) 
            const splitAddress = pdf.splitTextToSize(address, maxW - iconSize - 1.2);

            // item?.proAddressLineOne
            //   ? removeDuplicateWords(
            //       [item.proAddressLineOne, item.addressState, item.addressCountry]?.filter(Boolean)?.join(", ")
            //     )
            //   : removeDuplicateWords(
            //       [ item.addressCity, item.addressState, item.addressCountry, item.addressZipcode]?.filter(Boolean)?.join(", ")
            //     );
            const isDoubleLineAddress = splitAddress?.length > 1;

            // ── NAME ──
            // let textFullName=item?.proFullName || ""
            // pdf.setFont("helvetica", "bold");
            // pdf.setFontSize(13);
            // pdf.setTextColor(65, 65, 65);
            // textFullName = textFullName ? pdf.splitTextToSize(textFullName,maxW - iconSize - 2)[0] : "N/A";
            // pdf.text( capitalizeFirstLetter(textFullName || ""), nameX, rowName );
            let textFullName = item?.proFullName || ""
            pdf.setFont("helvetica", "bold");
            pdf.setFontSize(13);
            pdf.setTextColor(65, 65, 65);
            const textLines = textFullName ? pdf.splitTextToSize(textFullName, maxW - 2)[0] : ["N/A"];
            pdf.text(
                capitalizeFirstLetter(textLines),
                nameX,
                rowName
            );

            if (hasBoardCertified) {
              const badgeY = rowName + 1.5;
              const badgeW = 30;
              pdf.setFillColor(220, 252, 231);
              pdf.roundedRect(nameX, badgeY, badgeW, boardBadgeH, 1.5, 1.5, "F");
              pdf.setFontSize(7);
              pdf.setFont("helvetica", "bold");
              pdf.setTextColor(22, 101, 52);
              pdf.text("Board Certified", nameX + 2, badgeY + 4);
            }

            if (locationIconBase64) {
              pdf.addImage(locationIconBase64, undefined, nameX, rowAddress - iconSize + 0.5, iconSize, iconSize);
            }

            pdf.setFont("helvetica", "normal");
            pdf.setFontSize(8);
            pdf.setTextColor(60, 60, 60);

            if (splitAddress?.[0]) {pdf.text(splitAddress?.[0], textAfterIcon, rowAddress)}

            if (splitAddress?.[1]) {pdf.text(splitAddress?.[1], textAfterIcon, rowAddress + 4)}

            const addressOffset = isDoubleLineAddress ? 4 : 0;
            const rowPhone = y + 17 + boardOffset + addressOffset;
            const rowEmail = y + 22 + boardOffset + addressOffset;
            // const rowMedicaid = y + 27 + boardOffset + addressOffset;

            // ── PHONE ──
            const phone = item?.proPrimaryContact
              ? checkForInvalidContact(item?.proPrimaryContact) : "N/A";
            if (phoneIconBase64) {
              pdf.addImage( phoneIconBase64, undefined, nameX, rowPhone - iconSize + 0.5, iconSize, iconSize);
            }
            pdf.setFont("helvetica", "normal");
            pdf.setFontSize(8);
            pdf.setTextColor(65, 65, 65);
            pdf.text(phone, textAfterIcon, rowPhone);

            // ── EMAIL ──
            const email = check_validEmail(item?.proPrimaryEmail) || "";
            if (emailIconBase64) {
              pdf.addImage(emailIconBase64,undefined,nameX,rowEmail - iconSize + 0.5,iconSize,iconSize );
            }
            pdf.setFont("helvetica", "normal");
            pdf.setFontSize(8);
            pdf.setTextColor(65, 65, 65);
            const emailDisplay = email ? pdf.splitTextToSize(email, maxW - iconSize - 2)[0] : "N/A";
            pdf.text(emailDisplay, textAfterIcon, rowEmail);

            const isGlobal = item?.differentPriorityLevelIds?.includes(1);
            const rowGlobal = rowEmail + 5;
            if (isGlobal) {
              const cbSize = 3.5;
              const cbX = nameX;
              const cbY = rowGlobal - cbSize + 0.5;

              pdf.setDrawColor(114, 12, 32);
              pdf.setLineWidth(0.4);
              pdf.rect(cbX, cbY, cbSize, cbSize);

              pdf.setFillColor(114, 12, 32);
              pdf.rect(cbX, cbY, cbSize, cbSize, "F");

              pdf.setDrawColor(255, 255, 255);
              pdf.setLineWidth(0.6);
              pdf.line(cbX + 0.6, cbY + cbSize / 2, cbX + cbSize / 2 - 0.2, cbY + cbSize - 0.8);
              pdf.line(cbX + cbSize / 2 - 0.2, cbY + cbSize - 0.8, cbX + cbSize - 0.5, cbY + 0.7);

              pdf.setFont("helvetica", "normal");
              pdf.setFontSize(8);
              pdf.setTextColor(65, 65, 65);
              pdf.text("Global", cbX + cbSize + 1.5, rowGlobal);
            }

            // ── MEDICAID ──
            const medicaid = getMedicaidText(item);

            let currentY = (isGlobal ? rowGlobal : rowEmail) + 4;

            if (medicaid?.text) {
              pdf.setFont("helvetica", "normal");
              pdf.setFontSize(8);
              pdf.setTextColor(
                medicaid?.highlight ? 21 : 60,
                medicaid?.highlight ? 87 : 60,
                medicaid?.highlight ? 36 : 60
              );
              pdf.text(medicaid.text, nameX,  currentY);
              currentY += 6;
            }

            // ── BOARD ──
            // const allTags = preferedType.filter((p) =>
            //   [1]?.includes(p.value)
            // );

            // drawTagsAutoWrap(pdf, allTags, currentY, item, nameX, x, cardWidth);

            pdf.setTextColor(0, 0, 0);

            if (i % 2 === 0) {
              x += cardWidth + gap;
            } else {
              x = margin;
              y += cardHeight + gap;
            }
          }

          const totalPages = pdf.getNumberOfPages();
          for (let p = 1; p <= totalPages; p++) {
            pdf.setPage(p);
            addPageNumber(pdf, p, totalPages);
          }

          pdf.save("Professionals.pdf");
            setLoader(false);


   };

  const removeDuplicateWords = (text) => {
    const parts = text.split(/(\s+|,)/);
    const seen = new Set();
    return parts?.filter((part) => {
      const clean = part.trim().toLowerCase();
      // keep spaces and commas
      if (!clean || part === "," || /^\s+$/.test(part)) {
        return true;
      }
      if (seen.has(clean)) {
        return false;
      }
      seen.add(clean);
      return true;
    })
      .join("")
      .replace(/\s+,/g, ",")
      .replace(/,+/g, ",")
      .trim();
  };

  const handlePrintExcel = async () => {
    // if (boardCertifiedCount(removeDuplicate(professionalList)) ?.length === 0) {
    if ((removeDuplicate(professionalList))?.length === 0) {
      message.info("No professionals available to download");
      return;
    }
    setLoader(true);
    const fields = [
      { label: "Name", key: "proFullName" },
      // { label: "Email", key: "proPrimaryEmail" },
      { label: "Phone", key: "proPrimaryContact" },
      { label: "Address", key: "proAddressLineOne" },
      { label: "Category", key: "proType" },
      { label: "Preferred Partner Marking", key: "differentPriorityLevelIds" },
    ];

    // const data = boardCertifiedCount(removeDuplicate(professionalList));
    const data = (removeDuplicate(professionalList));

    // Remove duplicate address words but keep commas
    const removeDuplicateWords = (text) => {
      const parts = text.split(/(\s+|,)/);
      const seen = new Set();
      return parts?.filter((part) => {
          const clean = part.trim().toLowerCase();

          // Keep spaces and commas
          if (!clean || part === "," || /^\s+$/.test(part)) {
            return true;
          }
          if (seen.has(clean)) {
            return false;
          }
          seen.add(clean);
          return true;
        })
        .join("")
        .replace(/\s+,/g, ",")
        .replace(/,+/g, ",")
        .trim();
    };

    // Map data
    const rows = data.map((item) => {
      const row = {};
      fields.forEach(({ label, key }) => {
        const address = `${item?.proAddressLineOne || ""}, ${item?.addressCity || ""}, ${item?.addressState || ""}, ${item?.addressCountry || ""}`;
        const val =  label === "Address" ? removeDuplicateWords(address) : label === "Phone" ? checkForInvalidContact(item[key]) : label === "Category" ? item[key] : label === "Preferred Partner Marking" ? (item?.differentPriorityLevelIds?.includes(1) ? "Global" : "") : item[key];

        if (typeof val === "boolean") {
          row[label] = val ? "Yes" : "No";
        } else if (label === "Preferred Partner Marking") {
          row[label] = val; // keep blank as blank
        } else {
          row[label] = val ?? "—";
        }
      });
      return row;
    });

    // Create worksheet
  const ws = XLSX.utils.json_to_sheet(rows);

    // Header Style
const headerStyle = {
  font: {
    bold: true,
    color: { rgb: "333333" },
    sz: 12,
  },
  fill: {
    fgColor: { rgb: "FFFFFF" },
  },
  alignment: {
    horizontal: "center",
    vertical: "center",
  },
  border: {
    top: {
      style: "thin",
      color: { rgb: "D3D3D3" },
    },
    bottom: {
      style: "thin",
      color: { rgb: "D3D3D3" },
    },
    left: {
      style: "thin",
      color: { rgb: "D3D3D3" },
    },
    right: {
      style: "thin",
      color: { rgb: "D3D3D3" },
    },
  },
};

    // Apply header style
    fields.forEach((field, index) => {
      const cellAddress = XLSX.utils.encode_cell({r: 0,c: index});
     if (ws[cellAddress]) {
        ws[cellAddress].s = headerStyle;
      }
    });

    // Column widths
    ws["!cols"] = fields.map(() => ({wch: 30}));
    // Header row height
    ws["!rows"] = [{ hpt: 28 }];
    // Workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb,ws,"Professionals");
    XLSX.writeFile(wb, "professionals.xlsx");
    setLoader(false);
  };



  const onSearch = () => {
    setPage(1);
    setHasMore(true);
    fetchData(1, true);
  };

  const loadMore = () => {
    const next = page + 1;
    setPage(next);
    fetchData(next);
  };


  useEffect(() => {
      getProfessionalCategories()
  }, [specialty])

  const getProfessionalCategories = () => {
    let getApiResonse = Services.getProfessionalCategories();
    getApiResonse
      .then((res) => {
        // console.log("898responsedetails", res?.data?.data);
        setTempJsonObj(res?.data?.data)
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const handleSelectChange = (value, type) => {
    if (type === 'selectedProType') {
      setSelectedProType(value);
      setSubCategory([]); // reset subcategory when pro type changes
    } else if (type === 'subCategory') {
      setSubCategory(value);
    } else if (type == "prefered") {

    const { proUserId, values } = value;
    setProfessionalList(prev =>
      prev.map(item =>
        item.proUserId === proUserId
          ? {
              ...item,
              differentPriorityLevelIds: values
            }
          : item
      ));
  }}


  const toggleCheck = (id, key) => {
    setProfessionalList(prev =>
      prev.map(item =>
        item.proUserId === id
          ? { ...item, [key]: !item[key] }
          : item
      )
    );
  };

  // 🔹 chips
  const removeFilter = (val, type) => {
    if (type === "specialty") {
      setSelectSpecialty(prev => prev.filter(v => v !== val));
    } else if (type === "type") {
      setSelectedProType(prev => prev.filter(v => v !== val));
    } else {
      setSubCategory(prev => prev.filter(v => v !== val));
    }
  };


  const onChangeSelectNew = (value, type) => {
    if (type === 'specialty') {
       setSelectSpecialty(value);
       setSubCategory([]);
       setSelectedProType([]);
       setOpen1(false)
    } else if (type === 'selectedProfessionalValue') {
       setSelectedProfessionalValue(prev => [...prev, value]);
       setSubCategory([]);
    } else if (type == 'subCategory') {
      setSubCategory(prev => [...prev, value]);
    }
  }

  const onClickAdd = (activeProUserId) => {
    // console.log("klfjdlldkfjldfkj",professionalList)
    // const hasPriorityOne = professionalList?.some(item => (item?.priorityLevelId == 1 || item?.globelPriLevId == 1));
     const hasPriorityOne = professionalList?.some( item =>
    item?.differentPriorityLevelIds && item?.differentPriorityLevelIds?.length > 0
     );
  

    const filteredProfessionals = professionalList?.filter(value => {

      const oldValues =
        [...(value?.originalDifferentPriorityLevelIds || [])]
          ?.map(Number).sort();

      const newValues =
        [...(value?.differentPriorityLevelIds || [])]
          ?.map(Number).sort();

      return JSON.stringify(oldValues) !== JSON.stringify(newValues);
    });



   const hasExistingPreferred = professionalList?.some( item => item?.originalDifferentPriorityLevelIds?.length > 0 );

      if (hasExistingPreferred) {
      setIsUpdate(true);
    }

    if (!filteredProfessionals?.length) {

      const activeCard = professionalList?.find(item => item?.proUserId === activeProUserId);
      const activeCardHasSelection = activeCard?.differentPriorityLevelIds?.length > 0;
      const activeCardHasOriginal = activeCard?.originalDifferentPriorityLevelIds?.length > 0;

      if (!activeCardHasSelection && !activeCardHasOriginal) {
      message.error("Please select at least one professional to add/remove");
        setIsUpdate(false);
        return;
      }
      setOpenSelectId(null);
      setIsUpdate(false);
      return;
    }

    setOpenSelectId(null);
    setLoader(true);
    const createdBy = sessionStorage.getItem('stateObj')
    ? JSON.parse(sessionStorage.getItem('stateObj'))?.userId : null;

    const jsonObj = filteredProfessionals?.map(value => ({
        userId: value?.userId,
        proUserId: value?.proUserId,
        differentPriorityLevelIds: value?.differentPriorityLevelIds || [],
        updatedBy: createdBy,
      }));

    Services.postProfessionalListv2(jsonObj)
      .then((res) => {
        if (res?.data) {
          message.success(`Professionals ${hasPriorityOne ? "updated" : "added"} successfully`);
          const savedUserIds = new Set(filteredProfessionals?.map(p => p.proUserId));
          setProfessionalList(prev =>
            prev?.map(item =>
              savedUserIds.has(item.proUserId)
                ? { ...item, originalDifferentPriorityLevelIds: [...(item.differentPriorityLevelIds || [])] }
                : item
            )
          );
        }
      })
      .catch(() => {
        message.error("Failed to update professionals");
      })
      .finally(() => {
        // resetRefs(15);
        // setSearchPageNumber(1);
        // // fetchProfessionals(latLongAgnt.latitude, latLongAgnt.longitude, "", 15, 1, type);
        // fetchData(1, true)
        setLoader(false);
      });
  };

  const onClear = () => {
    const resetData = tempJsonObj?.map((cat) => ({
    ...cat,
    professionalTypes: cat?.professionalTypes?.map((type) => ({
      ...type,
      checked: false,
      professionalSubTypes: type?.professionalSubTypes?.map((sub) => ({
        ...sub,
        checked: false,
        professionalGeriatricianSubTypes:
          sub?.professionalGeriatricianSubTypes?.map((geri) => ({
            ...geri,
            checked: false
          })),
      })),
    })),
  }));

   setTempJsonObj(resetData);
   setSelectedLocations([])
   setCheckedPlaces([])
    setIsBoardCertified([
    { label: "Board Certified", value: true, checked: false },
    { label: "Non-Board Certified", value: false, checked: false }]);
    setInputValue("");
    setSelectSpecialty(null);
    setSelectedProType([]);
    setSubCategory([]);
    setProfessionalList([]);
    setHasMore(true);
    setPage(1);
    setsearchType(null)
  };


  const boardCertifiedCount = useCallback((data) =>{
     if(isBoardCertified == true){
      return data?.filter(item => !isNullUndefine(item.board))
     }else{
      return data
     }
  },[isBoardCertified])

// console.log("5543wfesd_specialty",specialty)
// console.log("efwd",tempJsonObj)

useEffect(() => {
  const calculateLength = async () => {
    const fetchSubCategriesResponse = await fetchSubCategriesLabel();
    const fetchSubProTypeResponse = await fetchSubProTypeLabel();
    const fetchCheckedSubGeriatricianTypeResponse =await fetchCheckedSubGeriatricianTypeLabel();

    console.log(
      "__fetchSubCategriesResponse",
      fetchSubCategriesResponse,
      "fetchSubProTypeResponse",fetchSubProTypeResponse,
      "fetchCheckedSubGeriatricianTypeResponse",fetchCheckedSubGeriatricianTypeResponse
    );

    let total = [
      ...(fetchSubCategriesResponse || []),
      ...(fetchSubProTypeResponse || []),
      ...(fetchCheckedSubGeriatricianTypeResponse || [])
    ];
      // (fetchSubCategriesResponse || "") +
      // (fetchSubProTypeResponse || "") +
      // (fetchCheckedSubGeriatricianTypeResponse || "");
      // total=(total==0)?"":total
      console.log("wesac",total)
    setGetLength(total);
  };

  calculateLength();
}, [tempJsonObj]);


  const handleDropdownVisibleChange = (visible, item) => {
    if (visible) {
    setOpenSelectId(item.proUserId);
    } else {
      setOpenSelectId(null);
    }
  };

  // Close custom dropdown on outside click
  useEffect(() => {
    const handleOutside = (e) => {
      if (!e.target.closest(".custom-pref-dropdown")) {
        setOpenSelectId(null);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  // const handleDropdownVisibleChange = (visible, item) => {
  //   if (visible) {

  //   const unsavedCardId = Object.keys(dropdownOriginalValuesRef.current).find((proUserId) => {
  //     const originalVals = [...(dropdownOriginalValuesRef.current[proUserId] || [])]?.map(Number)?.sort();
  //     const currentItem = professionalList.find((p) => String(p.proUserId) === String(proUserId));
  //     const currentVals = [...(currentItem?.differentPriorityLevelIds || [])]?.map(Number)?.sort();
  //     return JSON.stringify(originalVals) !== JSON.stringify(currentVals);
  //   });

  //   if (unsavedCardId) {
  //     if (!warningShownRef.current[unsavedCardId]) {
  //       warningShownRef.current[unsavedCardId] = true;
  //       message.warning("Please save the preferences before proceeding.");
  //       setTimeout(() => {
  //         warningShownRef.current[unsavedCardId] = false;
  //       }, 500);
  //     }
  //     return;
  //   }

  //     warningShownRef.current[item.proUserId] = false;
  //     dropdownOriginalValuesRef.current[item.proUserId] = [...(item?.differentPriorityLevelIds || [])];
  //     setOpenSelectId(item.proUserId);
  //     return;
  //   }

  //   const originalVals = dropdownOriginalValuesRef.current[item.proUserId] || [];
  //   const currentVals = item?.differentPriorityLevelIds || [];
  //   const hasUnsavedChanges = JSON.stringify([...originalVals].sort()) !== JSON.stringify([...currentVals]?.sort());

  //   if (!hasUnsavedChanges) {
  //     delete dropdownOriginalValuesRef.current[item.proUserId];
  //     delete warningShownRef.current[item.proUserId];
  //     setOpenSelectId(null);
  //     return;
  //   }

  //   if (!warningShownRef.current[item.proUserId]) {
  //     warningShownRef.current[item.proUserId] = true;
  //     message.warning("Please save the preferences before proceeding.");
  //     setTimeout(() => {
  //       warningShownRef.current[item.proUserId] = false;
  //     }, 500);
  //   }
  //   setOpenSelectId(item.proUserId);
  // };



// console.log("8932qwwa",getLength)

function selectSpecialityFun(val1){
    onChangeSelectNew(val1.value, "specialty")
    setOpen1(false)
}

const selected_Specaiality_Label=useMemo(()=>{
    // alert("Trigered")
    // console.log("qsax",specialtyType,specialty)
    const selected_Label=specialtyType?.find((val2)=>val2?.value==specialty)
    return selected_Label?.label ?? "Select Speciality"
},[specialty])

// function onChange_searchFun(event){
//     const event_value=event?.target?.value || null
//     console.log("f42FEWA",event_value)
//     setInputValue(event_value)
//     setOpen3(true)
// }


const onChange_searchFun = (e) => {

  const value = e.target.value;
  // console.log("23qdsa",value)
  setInputValue(value);

  // CLOSE DROPDOWN IF EMPTY

  if (!value.trim()) {

    setSuggestions([]);
    setOpen3(false);

    return;
  }

  // GOOGLE AUTOCOMPLETE SERVICE

  const service = new window.google.maps.places.AutocompleteService();

  service.getPlacePredictions(
    
    {input: value,
        locationBias: userLocation ? { center: userLocation, radius: 50000, } : undefined,
    },
    // { input: value, 
    //   componentRestrictions: { country: "us", }, 
    //   locationBias: { radius: 50000, center: { lat: 39.8283, lng: -98.5795, }, }, 
    // },

    (predictions, status) => {

      if (
        status !==
        window.google.maps.places.PlacesServiceStatus.OK
      ) {

        setSuggestions([]);
        setOpen3(false);

        return;
      }

      setSuggestions(predictions || []);

      setOpen3(true);

    }
  );

};




function openCategory_DDn(){
    if(specialty==null){
        message.warning("Please select a speciality ");
        return 
    }
    setOpen(!open)
}


// const handleSelectLocation = (location) => {

//   const exists =
//     selectedLocations.find(
//       (item) =>
//         item.place_id === location.place_id
//     );

//   // REMOVE IF EXISTS
//   console.log("Fea",location)

//   if (exists) {

//     const filtered =
//       selectedLocations.filter(
//         (item) =>
//           item.place_id !== location.place_id
//       );
     
//     setSelectedLocations(filtered);

//   }

//   // ADD IF NOT EXISTS

//   else {

//     setSelectedLocations([
//       ...selectedLocations,
//       location
//     ]);

//   }

// };


const handleSelectLocation = (location) => {

  // ALREADY SELECTED ?

 
  // console.log("fwedc",location)
  const exists = checkedPlaces.includes(location.place_id);

  // console.log("ewsa",exists)
  // REMOVE LOCATION + ALL RELATED CHIPS

  if (exists) {

    setCheckedPlaces((prev) =>
      prev.filter(
        (id) => id !== location.place_id
      )
    );
  
    setSelectedLocations((prev) =>
      prev.filter(
        (item) =>
          item.place_id !== location.place_id
      )
    );
  
    return;
  }

  // GOOGLE GEOCODER

  const geocoder =  new window.google.maps.Geocoder();

  geocoder.geocode({  placeId: location.place_id,},(results, status) => {

      if (
        status !== "OK" ||
        !results?.[0]
      ) {
        return;
      }

      const components = results[0].address_components;
      // console.log("2fewcas",components)
      const extracted = [];

      components.forEach((comp) => {
        const types = comp.types;

        // ZIPCODE
        if (types.includes("postal_code")) {
          extracted.push({
            Value: comp.long_name,
            Type: "Zipcode",
          });
        }

        // CITY
        if (types.includes("locality")) {
          extracted.push({
            Value: comp.long_name,
            Type: "City",
          });
        }

        // STATE
        if (
          types.includes("administrative_area_level_1")
        ) {
          extracted.push({
            Value: comp.short_name,
            Type: "State",
          });
        }

        // COUNTY
        if (
          types.includes("administrative_area_level_2")
        ) {
          extracted.push({
            Value: comp.long_name,
            Type: "County",
          });
        }
      });


      // console.log("fwe",extracted,"ewdsa_selectedLocations",selectedLocations,"location",location)

      // REMOVE EMPTY + DUPLICATES
      const uniqueData = extracted.filter(
        (item, index, self) =>
          item.Value &&
          index ===
            self.findIndex(
              (obj) =>
                obj.Value === item.Value &&
                obj.Type === item.Type
            )
      );

      // CREATE CHIPS
      const chipsData = uniqueData.map(
        (item, index) => ({
          chip_id: `${location.place_id}-${index}`,

          place_id: location.place_id,

          Value: item.Value,

          Type: item.Type,
        })
      );

      setCheckedPlaces((prev) => [
        ...prev,
        location.place_id
      ]);

      // console.log(chipsData);

      // PREVENT DUPLICATE LOCATION

          setSelectedLocations((prev) => {

            const filteredNewChips =
              chipsData.filter(
                (newChip) =>
          
                  !prev.some(
                    (oldChip) =>
                      oldChip.Value === newChip.Value &&
                      oldChip.Type === newChip.Type
                  )
              );
          
            return [
              ...prev,
              ...filteredNewChips,
            ];
          
          });

    });

};

    function removeLocationFun(value){
      const removeItem=value
      // console.log("fweds",removeItem,"selectedLocations",selectedLocations)
      const filterSelectedLocation=selectedLocations?.filter((value1)=>value1?.chip_id!==removeItem?.chip_id && value1?.Value!==removeItem?.Value)
      setSelectedLocations(filterSelectedLocation)
    }

    function focusInputBox(){
      // inputSearchRef.current.focus();
      setIsFocused(true)
    }

    function removeAllSelectedLocations(){
      setSelectedLocations([])
      setCheckedPlaces([])
      setIsFocused(true)
    }

    function checkForInvalidContact(contactNumb){
      
      const getValue_withoutBracket_And_CC=formatPhoneNumberWithoutCntryCode_WIthoutBracket(contactNumb,"Without_CC_bracket")
      const getValue_without_CC=formatPhoneNumberWithoutCntryCode_WIthoutBracket(contactNumb,"")
      const excludedContact = [
        '0',
        '0000000000',
        '1111111111',
        '2222222222',
        '3333333333',
        '4444444444',
        '5555555555',
        '6666666666',
        '7777777777',
        '8888888888',
        '9999999999',
        '1234567890',
      ];
      let excludedContact_Value=excludedContact?.some(value2=>value2==getValue_withoutBracket_And_CC)
      return (excludedContact_Value==true || isNullUndefine(contactNumb))?"N/A":getValue_without_CC
    }

    function check_validEmail(itemEmail){
        const checkValidity=itemEmail?.endsWith("@aorg.com")
        return (checkValidity==true || isNullUndefine(itemEmail))?"N/A":itemEmail
    }





// console.log("edasx",selectedLocations,"_checkedPlaces",checkedPlaces)
// console.log('ewAS',isFocused)

  return (
    <>
      <div className="PrefferedProfessionalMainDiv">
    
        {/* ----- */}
        <div className="align_first_div">
          <h2>Strategic Partners</h2>
          <div className="d-flex buttonsResizing justify-content-end p-0">

            <button className="downloadPdfBtn" 
            onClick={handlePrintPDF}
            >
                <span className="plusIcon">+</span>
                Download PDF
            </button>
            <button className="downloadPdfBtn"
             onClick={handlePrintExcel}
             >
                 <img src="download_btn_marron.svg" className="resizeImage_1"/>
                Download Excel
            </button>
            <button className="downloadPdfBtn ChnageBg_color" 
            onClick={() => setShowAddNewPopup(true)}
            >
                <img src="person_add.svg" className="resizeImage_1"/>
                 Add Professional
            </button>
          </div>
        </div>
        {/* ---- sEARCH BAR*/}
        <div className=""     ref={dropdownRef4}>
            <div className="mainDivW_dth">
                <div className="inputWrapperMain " >

                  {!isFocused && selectedLocations?.length > 0 && ( // Options
                    <>
                    <div className="selectedChipsWrapper w_60 "  >
                    {selectedLocations?.map((item) => (
                          <div
                            key={item?.chip_id}
                            className="chipDesign"
                          >
                            {item?.Value}

                            <svg
                              className="crossLocation_icons"
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="black"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              onClick={()=>{removeLocationFun(item)}}
                            >
                              <line x1="18" y1="6" x2="6" y2="18"></line>
                              <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>

                          </div>

                          ))}
                    </div>
                    
                    <div className="cursor-wrapper w_40" onClick={() => focusInputBox() }>
                      {/* <div className="cursor-bar">|</div> */}
                    </div>
                    <img src="globalCrossIcon.svg" className="resizeImage__width1" onClick={removeAllSelectedLocations}/>

                    </>
                  )}


                {/* INPUT */}

                {(isFocused  || (!isFocused && selectedLocations?.length==0) ) && ( // Input Box
                  <>
                    <svg className="search_iconWIdth" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="11" cy="11" r="8"></circle>
                      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    </svg>
                    <input
                      type="text"
                      placeholder="Search by Zip, State, City, County..."
                      className="inputSearch_Profess"
                      onChange={(e) => onChange_searchFun(e)}
                      onFocus={(e) =>setIsFocused(true)}
                      value={inputValue}
                      id="search_input"
                      autoFocus
                      tabIndex={0}
                    />
                  
                  </>
                )}

             </div>

                     
              {open3 && (  // Dropdown options
                <div
                  ref={dropdownRef3}
                  className="dropdownDesign2"
                >

                  {suggestions.map((item) => {

                      const checked =
                      checkedPlaces.includes(item.place_id);

                    return (

                      <div
                        key={item.place_id}
                        style={{
                          padding: "1px 1px",
                          borderRadius: 6,
                          marginBottom: 4,
                          marginTop: 2
                        }}
                      >

                        <label className="LabelStyle_dp1">

                          <input
                            type="checkbox"
                            checked={checked}
                            className="checkBoxSize2"
                            onChange={() =>
                              handleSelectLocation(item)
                            }
                          />

                        <span>
                          {item?.structured_formatting?.main_text}
                        </span>

                        <span
                          style={{
                            color: "#777",
                            marginLeft: "5px",
                            fontSize: "13px"
                          }}
                        >
                          {item?.structured_formatting?.secondary_text}
                        </span>



                        </label>

                      </div>

                    );

                  })}

                </div>
              )}

            </div>
            

        </div>
        {/* ---Speciality--- */}
        <div className="mt-2  speciality_downpdown_div">

            {<div className="form_Select_Speciality">
                <div
                    onClick={() => setOpen1(!open1)}
                    style={{
                        border: "0.1rem solid #c5c0c09e",
                        padding: "10px 12px",
                        borderRadius: 6,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        cursor: "pointer",
                        background: "#fff",
                        fontSize: 14,
                        position: "relative",
                        height: "50px"
                    }}
                    >
                    {/* <span>{getLength}{"Select type"}</span> */}
                    <span>{selected_Specaiality_Label}</span>

                    {/* Arrow */}
                    <span
                        style={{
                        display: "inline-block",
                        transition: "transform 0.2s",
                        transform: open1 ? "rotate(180deg)" : "rotate(0deg)"
                        }}
                    >
                        <img src="black_select.svg" className="blackSelect_img"/>
                         </span>
                    </div>
                    {open1 && (
                        <div 
                        ref={dropdownRef1}
                        className="dropdownDesign"
                        >
                        {specialtyType
                            ?.map(val1 =>{
                                return(
                                <>
                                <div key={val1?.value} style={{ margin: "6px 4px" }}>
                                    <label onClick={()=> onChangeSelectNew(val1?.value, "specialty")}>{val1?.label}</label>
                                </div>
                            </>
                          )})}

                        </div>
                    )}
                            

              </div>}


                
                 


            {<div className="subCate_div">
                <div
                    onClick={openCategory_DDn}
                    style={{
                        border: "0.1rem solid #c5c0c09e",
                        padding: "10px 12px",
                        borderRadius: 6,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        cursor: "pointer",
                        background: "#fff",
                        fontSize: 14,
                        position: "relative",
                        flex:1,
                    }}
                    className="SpecilaistDiv">
                     <span className="catgry_label chipsWrapper"  ref={containerRef}>
                      {Array.isArray(getLength) && getLength.length > 0 ? (
                        <>
                         {/* {getLength.slice(0).map((item) => ( */}
                            <div className="chip chip-item" >
                              {getLength?.[0]}
                            </div>
                          {/* ))} */}

                          {getLength?.length>1 && (
                            <div className="chip moreChip">+{getLength?.length-1}</div>
                          )}

                          </>
                          ) : (
                            <span>Select type</span>
                          )}
                       
                    </span>


                    {/* Arrow */}
                    <span
                        style={{
                        display: "inline-block",
                        transition: "transform 0.2s",
                        transform: open ? "rotate(180deg)" : "rotate(0deg)"
                        }}
                    >
                        <img src="black_select.svg" className="blackSelect_img"/>
                        
                        {/* <span role="img" aria-label="down" class=" arrowHeighticon anticon anticon-down ant-select-suffix"><svg viewBox="64 64 896 896" focusable="false" data-icon="down" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path></svg></span> */}
                    </span>
                    </div>


                    {/* Dropdown */}
                    {open && (
                        <div ref={dropdownRef}
                        className="dropdownDesign"
                        >
                        {tempJsonObj
                            ?.filter(v => v.value == specialty)
                            ?.map(cat => {
                                return(
                                <>
                                <div key={cat?.value} style={{ margin: "6px 4px" }}>
                                    {cat?.professionalTypes.map(type => (
                                    <div key={type.value} style={{ padding: "1px 1px", borderRadius: 6, marginBottom: 4,marginTop:2 }}>

                                    {/* TYPE */}
                                    <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
                                    <input
                                        type="checkbox"
                                        checked={type?.checked || false}
                                        onChange={(e) => parentNodeCheck(type,e,"parentNode")}
                                        className="checkBoxSize"
                                    />
                                    {type.label}
                                    </label>

                                    {/* SUB TYPES */}
                                    {type?.checked==true &&
                                        <section style={{maxHeight: "170px",overflow: "hidden auto"}}>
                                        {(type?.professionalSubTypes || type?.professionalCategories || [])?.map(sub => (
                                            <>
                                            <div key={sub.value} style={{ paddingLeft: 24, marginTop: 6}}>
                                            <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 14, color: "#444" }}>
                                                <input
                                                type="checkbox"
                                                checked={sub?.checked || false}
                                                onChange={(e) => parentNodeCheck(sub,e,"childNode")}
                                                className="checkBoxSize"
                                                />
                                                {sub.label}
                                            </label>
                                            </div>
                                            {sub?.checked == true &&
                                                <>
                                    {sub?.professionalGeriatricianSubTypes?.map((subVal1) => (
                                    <>
                                <div key={subVal1.value} style={{ paddingLeft: 54, marginTop: 6 }}>
                                    <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 14, color: "#444"}}>
                                    <input type="checkbox" checked={subVal1?.checked || false}
                                        onChange={(e) => parentNodeCheck(subVal1, e, "subChildNode")}
                                        className="checkBoxSize"
                                    />

                                    {subVal1.label}
                                    </label>
                                </div>

                                {subVal1?.label === "MD" && subVal1?.checked && (
                                <div
                                    style={{paddingLeft: 78,marginTop: 6,display: "flex",flexDirection: "column",alignItems: "flex-start",gap: 6}} >

                                    {isBoardCertified?.map((item, index) => (

                                    <label
                                        key={index}
                                        style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", fontSize: 14, color: "#444" }} >
                                        <input
                                        type="checkbox"
                                        checked={item?.checked}
                                        onChange={(e) => {
                                            const checkedValue = e.target.checked;
                                            setIsBoardCertified(prev =>
                                            prev.map((val, i) =>
                                                i === index ? { ...val, checked: checkedValue } : val
                                            ))}}
                                        // style={{ height: "15px", width: "15px" }}
                                        />
                                        {item.label}
                                    </label>))}

                                        </div>
                                        )}
                                    </>
                                    ))}
                                                </>
                                                }
                                            </>

                                        ))}
                                    </section>
                                    }

                                </div>))
                                }
                            </div>
                            </>
                            )
                        })
                    }
                            </div>
                    )}

                </div>
            }
            <div className="buttons_spacing">
                <button onClick={onSearch} className="butonSearchUi_Maroon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                    className="searchIcon"
                    >
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    </svg>Search
                </button>
                <button onClick={onClear} className="butonSearchUi_Plain butonSearchUi_Plain_Clear">
                Clear
                </button>
            </div>

           
        </div>

    
      </div>
    
            <div className=" main_card_grid">
            <div className="card-grid">
            
            { !loading &&  (removeDuplicate(professionalList))?.map((item) => (<>
                  {/* Card 1 */}
                  <div className="card">

                    <img src={item?.profileURL ?? "./professionalDummyIcon.svg"} alt="profile" className="card-image" />

                    <div className="card-content">

                      <h2 className="card-title" title={capitalizeFirstLetter(item?.proFullName)}>
                      {capitalizeFirstLetter(item?.proFullName)}
                      </h2>

                      {!isNullUndefine(item?.board) && (
                      <div className="card-badge">
                        Board Certified
                      </div>)}

                      <div className="card-info">

                        <div className="info-row addressRowOneLine">
                          <span> <img src="location_on.svg" width="18px" alt="email" className="sm-img mt-0 me-1" /></span>
                          <p title={getAddressFun(item)} >{getAddressFun(item)}
                      </p>
                        </div>

                        <div className="info-row">
                        <span> <img src="call.svg" width="18px" alt="email" className="sm-img mt-0 me-1" /></span>
                          <p title={checkForInvalidContact(item?.proPrimaryContact)}>{checkForInvalidContact(item?.proPrimaryContact)}</p>
                        </div>

                        <div className="info-row">
                        <span> <img src="mail.svg" width="18px" alt="email" className="sm-img mt-0 me-1" /></span>
                          <p title={check_validEmail(item?.proPrimaryEmail)}>{check_validEmail(item?.proPrimaryEmail)}</p>
                        </div>

                      </div>
                  <div style={{ position: "absolute", right: "10px", display: "flex", bottom: "0px", fontSize: "12px", width: "45%" }}>
                    <div style={{ width: "100%", marginBottom: '.5rem', display: "flex" }}>
                      <div className="w-100 custom-pref-dropdown" style={{ marginBottom: "5px", position: "relative" }}>

                        <div
                          onClick={() => setOpenSelectId(openSelectId === item.proUserId ? null : item.proUserId)}
                          style={{
                            border: "1px solid #899499",
                            borderRadius: 6,
                            padding: "5px 10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            cursor: "pointer",
                            background: "#fff",
                            minHeight: 34,
                            flexWrap: "wrap",
                            gap: 4,
                          }}
                        >
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 4, flex: 1 }}>
                            {item?.differentPriorityLevelIds?.length > 0 ? (
                              item.differentPriorityLevelIds?.map((val) => {
                                const found = preferedType?.find(p => p.value === val);
                                return found ? (
                                  <span key={val} style={{
                                    display: "inline-flex", alignItems: "center", gap: 4,
                                    background: "#f5f5f5", border: "1px solid #d9d9d9",
                                    borderRadius: 4, padding: "1px 6px", fontSize: 12
                                  }}>
                                    <input type="checkbox" checked readOnly
                                      style={{ accentColor: "#720C20", pointerEvents: "none", width: 13, height: 13 }} />
                                    {found.label}
                                    <span
                                      onMouseDown={(e) => {
                                        e.stopPropagation();
                                        const newVals = item.differentPriorityLevelIds?.filter(v => v !== val);
                                        handleSelectChange({ proUserId: item.proUserId, values: newVals }, "prefered");
                                      }}
                                      style={{ cursor: "pointer", marginLeft: 2, fontSize: 13, lineHeight: 1, color: "#999" }}>×</span>
                                  </span>
                                ) : null;
                              })
                            ) : (
                              <span style={{ color: "#899499", fontSize: 13 }}>Preferred partner marking</span>
                            )}
                          </div>
                          {/* Clear all */}
                          {item?.differentPriorityLevelIds?.length > 0 && (
                            <span
                              onMouseDown={(e) => {
                                e.stopPropagation();
                                handleSelectChange({ proUserId: item.proUserId, values: [] }, "prefered");
                              }}
                              style={{ color: "#474747", fontSize: 16, cursor: "pointer", marginRight: 4 }}>×</span>
                          )}
                          {/* Arrow */}
                          <span style={{
                            display: "inline-flex",
                            alignItems: "center",
                            flexShrink: 0,
                            transition: "transform 0.2s",
                            transform: openSelectId === item.proUserId ? "rotate(180deg)" : "rotate(0deg)",
                          }}>
                            <img src="black_select.svg" style={{ width: 10, height: 10, display: "block" }} />
                          </span>
                    </div>

                        {openSelectId === item.proUserId && (
                          <div style={{
                            position: "absolute",
                            bottom: "calc(100% + 4px)",
                            left: 0,
                            right: 0,
                            background: "#fff",
                            border: "1px solid #d9d9d9",
                            borderRadius: 6,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                            zIndex: 100,
                            overflow: "hidden",
                          }}>
                            {preferedType.map((pref) => (
                              <div
                                key={pref.value}
                                onMouseDown={(e) => {
                                  e.stopPropagation();
                                  const current = item?.differentPriorityLevelIds || [];
                                  const newVals = current.includes(pref.value)
                                    ? current.filter(v => v !== pref.value)
                                    : [...current, pref.value];
                                  handleSelectChange({ proUserId: item.proUserId, values: newVals }, "prefered");
                                }}
                                style={{ padding: "8px 12px", cursor: "pointer", display: "flex", alignItems: "center",
                                  gap: 8,background: item?.differentPriorityLevelIds?.includes(pref.value) ? "#fff1f2" : "#fff",
                                  fontSize: 13}}>
                                <input
                                  type="checkbox"
                                  readOnly
                                  checked={item?.differentPriorityLevelIds?.includes(pref.value)}
                                  style={{ accentColor: "#720C20", pointerEvents: "none", width: 14, height: 14 }}
                                />
                                {pref.label}
                              </div>
                            ))}
                            {/* Save button */}
                            <div style={{ display: "flex", justifyContent: "flex-end", padding: "8px 12px", borderTop: "1px solid #e8e8e8" }}>
                              <button
                                onMouseDown={(e) => {
                                  e.stopPropagation();
                                  onClickAdd(item.proUserId);
                                }}
                                style={{height: 30, fontSize: 12, padding: "0 14px",backgroundColor: "rgb(114, 12, 32)", color: "#fff",border: "none", borderRadius: 6, cursor: "pointer"}}>
                                Save
                              </button>
                            </div>
                          </div>
                        )}

                      </div>
                    </div>
                  </div>
                    </div>
                  </div>
                  </>
                ))}
          </div>
            </div>

            {(removeDuplicate(professionalList))?.length > 0 && hasMore && (
            <div className="load-more" style={{ gridColumn: "1 / -1", textAlign: "center", padding: "16px 0" }}>
              <button onClick={loadMore} className="loadMoreButton">Load More ↓</button>
            </div>
            )}
            {!loading && (removeDuplicate(professionalList))?.length === 0 && (
              <Empty
                description="No professionals found"
              />
            )}

            {showAddNewPopup && (
              <AddProfessional
                setShowAddNewPopup={setShowAddNewPopup}
                visible={showAddNewPopup}
                onCancel={() => setShowAddNewPopup(false)}
              />
            )}
   
    </>
  );
};

export default PreferredProfessional2;